module.exports = __webpack_public_path__ + "img/facebook-brands.62d8b6ef.svg";